export default function isUndefined(value: any) {
  return typeof value === 'undefined'
}
